<template>
  <Teleport to="body">
    <div
      v-if="store.visible"
      class="debug-error-overlay"
      role="dialog"
      aria-modal="true"
      :aria-label="store.title"
    >
      <div class="debug-error-panel card shadow-lg">
        <div class="card-header d-flex justify-content-between align-items-center">
          <span class="fw-semibold">{{ store.title }}</span>
          <button
            type="button"
            class="btn-close"
            aria-label="Cerrar"
            @click="store.hide()"
          />
        </div>
        <div class="card-body">
          <p class="small text-muted mb-2">
            Diagnóstico interno. Copia el texto si un desarrollador te lo pide.
          </p>
          <textarea
            ref="taRef"
            class="form-control font-monospace small debug-error-textarea"
            readonly
            rows="14"
            :value="store.text"
            @focus="selectAll"
          />
          <div class="d-flex flex-wrap gap-2 mt-3">
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="onCopy"
            >
              Copiar al portapapeles
            </button>
            <button
              type="button"
              class="btn btn-outline-secondary btn-sm"
              @click="selectAll"
            >
              Seleccionar todo
            </button>
            <button
              type="button"
              class="btn btn-outline-dark btn-sm ms-auto"
              @click="store.hide()"
            >
              Cerrar
            </button>
          </div>
          <p v-if="copyHint" class="small text-success mt-2 mb-0">{{ copyHint }}</p>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { ref, watch, nextTick } from "vue";
import { useDebugErrorStore } from "@/store/debugErrorStore";

const store = useDebugErrorStore();
const taRef = ref(null);
const copyHint = ref("");

const selectAll = async () => {
  await nextTick();
  const el = taRef.value;
  if (el) {
    el.focus();
    el.select();
  }
};

const onCopy = async () => {
  copyHint.value = "";
  const ok = await store.copyToClipboard();
  copyHint.value = ok
    ? "Copiado."
    : "No se pudo copiar automáticamente; usa «Seleccionar todo» y copia manualmente.";
};

watch(
  () => store.visible,
  async (v) => {
    if (v) {
      copyHint.value = "";
      await nextTick();
      selectAll();
    }
  }
);
</script>

<style scoped>
.debug-error-overlay {
  position: fixed;
  inset: 0;
  z-index: 200000;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  box-sizing: border-box;
}

.debug-error-panel {
  width: 100%;
  max-width: min(640px, 100vw - 24px);
  max-height: min(90vh, 900px);
  overflow: auto;
}

.debug-error-textarea {
  resize: vertical;
  min-height: 200px;
  user-select: text;
  -webkit-user-select: text;
}
</style>
